<template>
  <div>
    <v-card min-height="390px" xs="12" md="4">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-row>
          <v-col md="4" xs="12">
            <v-text-field
              id="signup_info_adicional__nombres__text"
              name="signup_info_adicional__nombres__text"
              v-model="nombres"
              :counter="80"
              maxlength="80"
              :error-messages="getErrors('nombres', 'Los Nombres')"
              label="Nombres"
              required
              @input="submit"
              @blur="$v.nombres.$touch()"
              :disabled="this.isBusy"
            ></v-text-field>
          </v-col>
          <v-col md="4" xs="12">
            <v-text-field
              id="signup_info_adicional__paterno__text"
              name="signup_info_adicional__paterno__text"
              v-model="paterno"
              :counter="50"
              maxlength="50"
              :error-messages="getErrors('paterno', 'El Apellido Paterno')"
              label="Apellido Paterno"
              required
              @input="submit"
              @blur="$v.paterno.$touch()"
              :disabled="this.isBusy"
            ></v-text-field>
          </v-col>
          <v-col md="4" xs="12">
            <v-text-field
              id="signup_info_adicional__materno__text"
              name="signup_info_adicional__materno__text"
              v-model="materno"
              :counter="50"
              maxlength="50"
              :error-messages="getErrors('materno', 'El Apellido Materno')"
              label="Apellido Materno"
              required
              @input="submit"
              @blur="$v.materno.$touch()"
              :disabled="this.isBusy"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <fiel-validator-inline></fiel-validator-inline>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" xs="12">
            <v-text-field
              id="signup_info_adicional__rfc__text"
              name="signup_info_adicional__rfc__text"
              v-model="account.rfc"
              :counter="13"
              maxlength="13"
              label="RFC"
              required
              disabled
            ></v-text-field>
          </v-col>
          <v-col md="8" xs="12">
            <v-text-field
              id="signup_info_adicional__razon_social__text"
              name="signup_info_adicional__razon_social__text"
              v-model="account.razonSocial"
              :counter="249"
              maxlength="249"
              label="Razón Social"
              required
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { panelData, panelActions } from '@/store/helpers'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { notSpecialChars } from '@/utils/VuelidateCustoms'
import { signupActions, signupData } from '../store/signupWizardHelpers'
import FielValidatorInline from '@/modules/signers/components/FielValidatorInline'

export default {
  name: 'SignupInfoAdicional',
  components: {
    FielValidatorInline
  },
  props: {
    nombre: {
      required: true
    },
    apellidoP: {
      required: true
    },
    apellidoM: {
      required: true
    },
  },
  data() {
    return {
      vuelidateHelper: null,
      valid: false,
      lazy: false,
      nombres: '',
      paterno: '',
      materno: ''
    }
  },
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
    this.nombres = this.nombre
    this.paterno = this.apellidoP
    this.materno = this.apellidoM
    this.saveData()
  },
  validations: {
    nombres: { required, maxLength: maxLength(80), notSpecialChars },
    paterno: { required, maxLength: maxLength(50), notSpecialChars },
    materno: { maxLength: maxLength(50), notSpecialChars }
  },
  computed: {
    ...panelData,
    ...signupData
  },
  methods: {
    ...panelActions,
    ...signupActions,
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.$v.$invalid) {
          this.saveData()  
        } else {
          this.setInfoAdicional({
            nombres: '',
            paterno: '',
            materno: ''
          })
        }
      }
    },
    saveData(){
      this.setInfoAdicional({
        nombres: this.nombres,
        paterno: this.paterno,
        materno: this.materno
      })
    }
  }
}
</script>
